
// import Notice from "~/components/home/notice.vue";
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
import JoinUs from "../joinUs/index.vue";
export default {
  components: {
    CommonTitle,
    BannerTop,
    JoinUs
    // Notice
  },
  data() {
    return {
      team: [
        {
          name: 'aboutUs.team.CEO',
          img: 'CEO'
        },
        {
          name: 'aboutUs.team.CFO',
          img: 'CFO'
        },
        // {
        //   name: 'aboutUs.team.CTO',
        //   img: 'CTO'
        // }
      ],
      imageList: [
        {
          id: 1,
          src:  require(`@/static/images/applicationIntroduction/b_intro_2.png`),
        }
      ],
      imageList2: [
        {
          id: 2,
          src: require(`@/static/images/applicationIntroduction/b_intro_1_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
        }
      ],
      b_intro_2: require(`@/static/images/applicationIntroduction/b_intro_2_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
      b_intro_3: require(`@/static/images/applicationIntroduction/b_intro_3_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
      b_intro_4: require(`@/static/images/applicationIntroduction/b_intro_4_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
      b_intro_5: require(`@/static/images/applicationIntroduction/b_intro_5_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
    }
  },
  computed: {
    contentList() {
      let data = this.$t('aboutUs.contentList');
      return data;
    },
    contentList1(){
      let data = this.$t('aboutUs.contentList1');
      return data;
    }
  },
  methods:{
    mouseover(){
      return false
    },
    contextmenu($event){
      if ($event.which == 2 || $event.which == 3) {
        $event.returnValue = false;
        return false;
      }
    }
  }
}
